import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Auth/Login';
import Signup from './pages/Auth/Signup';
import Dashboard from './pages/Dashboard/Dashboard';
import OnboardingFlow from './pages/Onboarding/OnboardingFlow';
import PaymentHistory from './pages/Dashboard/PaymentHistory';
import UpcomingPayments from './pages/Dashboard/UpcomingPayments';
import PromoCodeManager from './pages/Dashboard/PromoCodeManager';
import ManageBankAccounts from './pages/BankAccounts/ManageBankAccounts';
import VerifyBankAccount from './pages/BankAccounts/VerifyBankAccount';
import Integrations from './pages/Integrations/Integrations';
import Invoices from './pages/Dashboard/Invoices';
import Layout from './components/Layout/Layout';
export function App() {
  // This would normally be determined by an auth check
  const isAuthenticated = true;
  const hasCompletedOnboarding = true;
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={<Login data-id="element-3" />} data-id="element-2" />
        <Route path="/signup" element={<Signup data-id="element-5" />} data-id="element-4" />
        <Route path="/onboarding" element={isAuthenticated ? <OnboardingFlow data-id="element-7" /> : <Navigate to="/login" replace data-id="element-8" />} data-id="element-6" />
        {/* Protected routes with layout */}
        <Route path="/" element={isAuthenticated ? hasCompletedOnboarding ? <Layout data-id="element-10" /> : <Navigate to="/onboarding" replace data-id="element-11" /> : <Navigate to="/login" replace data-id="element-12" />} data-id="element-9">
          <Route index element={<Dashboard data-id="element-14" />} data-id="element-13" />
          <Route path="payment-history" element={<PaymentHistory data-id="element-16" />} data-id="element-15" />
          <Route path="upcoming-payments" element={<UpcomingPayments data-id="element-18" />} data-id="element-17" />
          <Route path="promo-codes" element={<PromoCodeManager data-id="element-20" />} data-id="element-19" />
          <Route path="bank-accounts" element={<ManageBankAccounts data-id="element-22" />} data-id="element-21" />
          <Route path="verify-bank-account/:id" element={<VerifyBankAccount data-id="element-24" />} data-id="element-23" />
          <Route path="integrations" element={<Integrations data-id="element-26" />} data-id="element-25" />
          {/* Add routes for the new accounting-related pages */}
          <Route path="invoices" element={<Invoices data-id="element-28" />} data-id="element-27" />
          <Route path="bills" element={<div data-id="element-30">Bills Page</div>} data-id="element-29" />
        </Route>
      </Routes>
    </Router>;
}